import React from "react";

const SEO = ({ title, description, type, image, keywords, schema }) => {
  const siteUrl = "https://tahashoes.vn";
  const siteName = "TaHa Shoes";
  
  // Clean path for canonical
  const path = window.location.pathname;
  const fullUrl = `${siteUrl}${path}`;
  
  const combinedTitle = `${title} | Tahashoes`;

  return (
    <>
      <title>{combinedTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type || "website"} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={combinedTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:locale" content="vi_VN" />
      {image && (
        <>
          <meta property="og:image" content={image.startsWith('http') ? image : `${siteUrl}${image}`} />
          <meta property="og:image:secure_url" content={image.startsWith('http') ? image : `${siteUrl}${image}`} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
        </>
      )}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={combinedTitle} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image.startsWith('http') ? image : `${siteUrl}${image}`} />}

      {/* Structured Data (JSON-LD) */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(Array.isArray(schema) ? schema : [schema])}
        </script>
      )}
    </>
  );
};

export default SEO;
